import { render, staticRenderFns } from "./SidebarContentView.vue?vue&type=template&id=20a47e87&"
import script from "./SidebarContentView.vue?vue&type=script&lang=js&"
export * from "./SidebarContentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports